module.exports = __webpack_public_path__ + "static/slide6-70b5f5906dcbe7c1348d2eec2d662ca2.jpg";